import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import loadUser from './util/load-user';
import MinimumDurationLoader from '@mapbox/mr-ui/minimum-duration-loader';
import LoaderFull from '@mapbox/mr-ui/loader-full';

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingUser: true,
      errorLoadingUser: false
    };
  }

  componentDidMount() {
    loadUser().then(response => {
      !response
        ? this.setState({ isLoadingUser: false, errorLoadingUser: true })
        : this.setState({ isLoadingUser: false, user: response });
    });
  }

  render() {
    const { isLoadingUser, errorLoadingUser, user } = this.state;
    const content = !errorLoadingUser ? <App user={user} /> : null;

    return (
      <MinimumDurationLoader
        isLoaded={!isLoadingUser && !!App}
        loader={<LoaderFull opaque={true} />}
      >
        <Provider store={store}>{content}</Provider>
      </MinimumDurationLoader>
    );
  }
}

const container = document.getElementById('app');
ReactDOM.render(<Index />, container);
